import React from "react";
import { useSession } from "../../authentications/SessionContext";
import styled from "styled-components";
import { PropagateLoader } from "react-spinners";

const TableLoader = ({ isLoading, children }) => {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;

  if (isLoading) {
    return (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {window.location.pathname.includes("storefront") ? (
          <PropagateLoader />
        ) : (
          <div className={`${isVTEX ? "loaderVtex" : "loader"}`} />
        )}
      </div>
    );
  }
  return <>{children}</>;
};

export default TableLoader;

const StoreLoader = styled.div`
  border: 8px solid #000;
  border-top: 8px solid #000;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  margin: auto;
`;
